import { IconNames } from '@dixa/lib-shared-habla';
import {
  isMarkActive,
  toggleMark,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyMark } from 'lib-knowledge-document-structure/plateTypes';

import { ToolbarButton } from '../toolbar';

type Props = {
  mark: MyMark;
  icon: IconNames;
};

const FormatButton = ({ mark, icon }: Props): JSX.Element => {
  const editor = useMyEditorRef();
  const markIsActive = isMarkActive(editor, mark);
  const clear: Array<MyMark> =
    mark === 'strikethrough'
      ? ['underline']
      : mark === 'underline'
        ? ['strikethrough']
        : [];

  return (
    <ToolbarButton
      isActive={markIsActive}
      onClick={() => toggleMark(editor, { key: mark, clear })}
      icon={icon}
    />
  );
};

export default FormatButton;
